// extracted by mini-css-extract-plugin
module.exports = {"table":"PalletsCost_table__1cA2X","table__link":"PalletsCost_table__link__2pEHS"};